import React from 'react';
import { Link } from 'react-router-dom';

const NotFound: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 font-ibm">
      <h1 className="text-6xl font-bold text-blue-800 mb-4">404</h1>
      <h2 className="text-2xl font-semibold text-gray-800 mb-4">
        Page Not Found
      </h2>
      <p className="text-gray-600 mb-8">ไม่สามารถเข้าถึงหน้านี้ได้</p>
      <Link
        to="/"
        className="font-ibm px-4 py-2 text-white bg-blue-600 rounded hover: focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
      >
        หน้าหลัก
      </Link>
    </div>
  );
};

export default NotFound;
